"use client";

import { useSyncExternalStore } from "react";
import {
  abonneer,
  momentopname,
  serverMomentopname,
  wisselFavoriet,
  verwijderFavoriet,
  favorietSleutel,
  alleenTeams,
  type Favoriet,
  type Soort,
} from "@/lib/favorieten";

// Geen provider nodig: de favorieten staan in localStorage, en dat is voor
// React een externe bron. Elk component dat ze nodig heeft abonneert zich er
// rechtstreeks op.
export function useFavorieten() {
  const favorieten = useSyncExternalStore(abonneer, momentopname, serverMomentopname);

  // Op de server en tijdens de eerste render is er nog geen opslag gelezen.
  // Daarmee weten componenten wanneer ze iets mogen beweren over wat je volgt.
  const geladen = useSyncExternalStore(
    abonneer,
    () => true,
    () => false,
  );

  return {
    favorieten,
    geladen,
    /** Alleen de teams: dat is wat de meeste schermen en de meldingen kennen. */
    teams: alleenTeams(favorieten),
    /** Volg je dit al? Werkt voor alle drie de soorten. */
    isFavoriet: (f: Favoriet) =>
      favorieten.some((x) => favorietSleutel(x) === favorietSleutel(f)),
    perSoort: (soort: Soort) => favorieten.filter((f) => f.soort === soort),
    wissel: (f: Favoriet) => wisselFavoriet(f),
    verwijder: (f: Favoriet) => verwijderFavoriet(f),
  };
}
